import { Localization } from './localization'

export const Service = { Localization }
